import React, { ReactNode, useEffect, useState } from 'react';
import { ThemeProvider } from 'styled-components';
import { darkTheme, theme } from './theme';
import { useAppSelector } from '../../hooks/appHooks';
import { AccessibilitySelectors } from '../accessability/redux';

interface ThemeProps {
  children?: ReactNode;
}

const Theme: React.FC<ThemeProps> = ({ children }) => {
  const isAmblyopiaOn = useAppSelector(
    AccessibilitySelectors.selectIsAmblyopiaOn,
  );
  const [activeTheme, setActiveTheme] = useState<any>(theme);

  useEffect(() => {
    if (isAmblyopiaOn) {
      setActiveTheme({ ...activeTheme, colors: darkTheme.colors });
    } else {
      setActiveTheme(theme);
    }
  }, [isAmblyopiaOn]);

  return <ThemeProvider theme={activeTheme}>{children}</ThemeProvider>;
};

export { theme, Theme };
